import React, { useCallback } from 'react';
import { useTimelineZoom } from '../timeline/utils/use-timeline-zoom';
import { useTranslations } from 'next-intl';
import { ToolButton } from '@crabs-ai/ds-react';
import { FitWidth } from '@crabs-ai/web-icons';

const DEFAULT_TIMELINE_ZOOM = 0;

export function FitTimelineButton() {
  const t = useTranslations();
  const { zoom, setZoom } = useTimelineZoom();

  const isDefault = zoom === DEFAULT_TIMELINE_ZOOM;

  const handleFit = useCallback(() => {
    if (isDefault) return;
    setZoom(DEFAULT_TIMELINE_ZOOM);
  }, [isDefault, setZoom]);

  return (
    <ToolButton
      size="sm"
      isTransparent={false}
      state={isDefault ? 'disabled' : 'default'}
      onClick={handleFit}
      disabled={isDefault}
      isShowTooltip
      tooltipNode={t('Editor.timeline-controls.fit-timeline')}
      tooltipPosition="top"
    >
      <FitWidth className="size-5" />
    </ToolButton>
  );
}
